export const getPrice = (priceSchedule, type) => {
    var index = priceSchedule.findIndex(x => x.type == type);
    var price = priceSchedule[index]?.price;
    return price;
}